module.exports = __webpack_public_path__ + "static/img/GAM-Default.cb148f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/GAM-Default.png
// module id = 1590
// module chunks = 0